/** An HTTP error from the API, carrying the status so callers can react to it. */
export class ApiError extends Error {
  readonly status: number
  /** The API's code for the refusal, when it names one: `message` is free text. */
  readonly reason?: string

  constructor(message: string, status: number, reason?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.reason = reason
  }
}
